const API_BASE = process.env.REACT_APP_API_URL; // Ensure no duplicate /api



export const API_ENDPOINTS = {

  // Auth
  token: `${API_BASE}/api/token/`,
  refreshToken: `${API_BASE}/api/token/refresh/`,
  activateAccountByToken: `${API_BASE}/api/auth/activate/`,
  resendActivation: `${API_BASE}/api/auth/resend-activation/`,
  changePasswordByToken: `${API_BASE}/api/auth/reset-password/`,
  forgotPassword: `${API_BASE}/api/auth/request-password-reset/`,
  changePassword: `${API_BASE}/api/auth/change-password/`,
  brandingLogo: `${API_BASE}/api/auth/branding/`,

  // MFA
  mfaStatus: `${API_BASE}/api/auth/mfa/status/`,
  mfaSetup: `${API_BASE}/api/auth/mfa/setup/`,
  mfaConfirm: `${API_BASE}/api/auth/mfa/confirm/`,
  mfaVerify: `${API_BASE}/api/auth/mfa/verify/`,
  mfaDisable: `${API_BASE}/api/auth/mfa/disable/`,
  mfaBackupCodes: `${API_BASE}/api/auth/mfa/backup-codes/`,
  mfaPolicy: `${API_BASE}/api/auth/mfa/policy/`,

  // Questionario
  questionarioCurrent: `${API_BASE}/api/questionari/questionario/current/`,
  questionarioDetail: (id) => `${API_BASE}/api/questionari/questionario/${id}/`,
  createQuestionario: `${API_BASE}/api/questionari/questionario/`,
  incompleteQuestions: (id) => `${API_BASE}/api/questionari/questionario/${id}/incomplete_questions/`,
  questionarioRisposte: (id) => `${API_BASE}/api/questionari/questionario/${id}/risposte/`,
  questionarioComplete: (id) => `${API_BASE}/api/questionari/questionario/${id}/complete/`,
  saveRisposta: (id) => `${API_BASE}/api/questionari/questionario/${id}/save_risposta/`,
  nis2Report: (id) => `${API_BASE}/api/questionari/questionario/${id}/nis2_report/`,
  allDomande: `${API_BASE}/api/questionari/questionario/domande/`,
  domandaDetail: (id) => `${API_BASE}/api/questionari/questionario/domande/${id}/`,
  opzioniRisposta: (domanda_id) => `${API_BASE}/questionari/questionario/domande/${domanda_id}/opzioni/`,
  allSezioni: `${API_BASE}/questionari/questionario/sezioni/`,

  // Assets
  allCompanyAssets: `${API_BASE}/api/assets/`,
  singleAsset: (id) => `${API_BASE}/api/assets/${id}/`,
  createNewAsset: `${API_BASE}/api/assets/`,
  updateAsset: (id) => `${API_BASE}/api/assets/${id}/`,
  deleteAsset: (id) => `${API_BASE}/api/assets/${id}/`,
  assetResendVerification: (id) => `${API_BASE}/api/assets/${id}/resend-verification/`,
  assetCheckDns: (id) => `${API_BASE}/api/assets/${id}/check-dns/`,
  assetVerifyByToken: (token) => `${API_BASE}/api/assets/verify/${token}/`,

  // Altri endpoint (che potrebbero avere URL diversi)
  aziendaDashboard: `${API_BASE}/api/aziende/dashboard/`,
  aziendaProfile: `${API_BASE}/aziende/me/`,
  codiciAttivazione: `${API_BASE}/aziende/codici-attivazione/`,
  manageEndpoints: `${API_BASE}/aziende/manage-endpoints/`,

  //CyberSurveillance
  // cyberSurveillance: `${API_BASE}/api/assets/cyber-angel/results/?force=true`,
  cyberSurveillance: `${API_BASE}/api/assets/cyber-angel/results/`,
  cyberSurveillanceStats: `${API_BASE}/api/assets/cyber-angel/stats/`,
  cyberSurveillanceVulnerability: `${API_BASE}/api/assets/cyber-angel/vulnerabilities/`,
  changeStatusVulnerability: (id) => `${API_BASE}/api/assets/cyber-angel/vulnerabilities/${id}/status/`,
  changeStatusCredential: (id) => `${API_BASE}/api/assets/cyber-angel/breaches/${id}/status/`,
  listCredenzialiEsposte: `${API_BASE}/api/assets/cyber-angel/credentials/`,

  //Enterprise Consent
  getAssociatedEnterprises: `${API_BASE}/api/enterprise/consent/azienda/links/`,
  handleConsent: (id) => `${API_BASE}/api/enterprise/consent/azienda/links/${id}/`,


  // Aziende
  aziendaDettagli: `${API_BASE}/api/aziende/me/`,
  aziendaInfo: `${API_BASE}/api/aziende/info/`,
  getSettori: `${API_BASE}/api/settori/`,
  setTipoAzienda: `${API_BASE}/api/aziende/info/`,

  // Onboarding Wizard
  onboardingStatus: `${API_BASE}/api/aziende/onboarding/status/`,
  onboardingStep: `${API_BASE}/api/aziende/onboarding/step/`,
  onboardingComplete: `${API_BASE}/api/aziende/onboarding/complete/`,
  onboardingSkip: `${API_BASE}/api/aziende/onboarding/skip/`,
  onboardingReset: `${API_BASE}/api/aziende/onboarding/reset/`,
  onboardingTourSteps: `${API_BASE}/api/aziende/onboarding/tour-steps/`,

  // Endpoint module endpoints
  endpointList: `${API_BASE}/api/endpoint/endpoints/`,
  endpointStateUpdate: (id) => `${API_BASE}/api/endpoint/${id}/state/`,
  pluginActivation: `${API_BASE}/api/endpoint/plugin-activation/`,
  fileAngelData: `${API_BASE}/api/endpoint/fileangel/`,
  aziendaFileAngelData: `${API_BASE}/api/endpoint/azienda/fileangel/`,
  aziendaFileAngelStats: `${API_BASE}/api/endpoint/azienda/fileangel/stats/`,
  browsingAngelData: `${API_BASE}/api/endpoint/browsing/`,
  aziendaBrowsingAngelData: `${API_BASE}/api/endpoint/azienda/browsing/`,
  aziendaBrowsingAngelStats: `${API_BASE}/api/endpoint/azienda/browsing/stats/`,

  //Legal Compliance
  pendingDocuments: `${API_BASE}/legal-compliance/api/pending-documents/`,
  acceptDocument: `${API_BASE}/legal-compliance/api/accettazioni/`,

  // NIS Certificate
  nisCertificatePreview: (companyId) => `${API_BASE}/legal-compliance/api/conformita/${companyId}/nis/certificato/preview/`,
  nisCertificatePdf: (companyId) => `${API_BASE}/legal-compliance/api/conformita/${companyId}/nis/certificato.pdf`,

  //MSSP
  validateSsoToken: `${API_BASE}/api/sso/validate-token/`,

  // ExportPDF
  exportPDF: `${API_BASE}/api/report/cyberlog/`,
  cyberlogTesti: `${API_BASE}/api/report/cyberlog/testi/`,

  // NetFlow / Networking Surveillance
    netflowTenants: `${API_BASE}/api/ordini/netflow-tenants/`,
    updateNetflowIncidentStatus: (tenantId, incidentId) => `${API_BASE}/api/ordini/netflow-tenants/${tenantId}/incidents/${incidentId}/update-status/`,
    addNetflowIncidentComment: (tenantId, incidentId) => `${API_BASE}/api/ordini/netflow-tenants/${tenantId}/incidents/${incidentId}/add-comment/`,
    netflowIncidentDetail: (tenantId, incidentId) => `${API_BASE}/api/ordini/netflow-tenants/${tenantId}/incidents/${incidentId}/`,
    netflowIpIntelligence: (tenantId) => `${API_BASE}/api/ordini/netflow-tenants/${tenantId}/ip-intelligence/`,
    ipIntelligenceLookup: (ip) => `${API_BASE}/api/ordini/ip-intelligence/lookup/?ip=${encodeURIComponent(ip)}`,
    
    // NetFlow Admin - Classification Patterns
    netflowClassificationPatterns: `${API_BASE}/api/ordini/netflow-admin/classification-patterns/`,
    netflowClassificationPatternsAdd: `${API_BASE}/api/ordini/netflow-admin/classification-patterns/add/`,
    netflowClassificationPatternsDelete: (patternId) => `${API_BASE}/api/ordini/netflow-admin/classification-patterns/${patternId}/`,
    netflowClassificationPatternsReload: `${API_BASE}/api/ordini/netflow-admin/classification-patterns/reload/`,
    netflowClassificationPatternsStats: `${API_BASE}/api/ordini/netflow-admin/classification-patterns/stats/`,
    
    // NetFlow Topology History
    netflowTopologyHistory: (tenantId) => `${API_BASE}/api/ordini/netflow-tenants/${tenantId}/topology-history/`,

  // Notifications (polling MVP) - routed under common app (`/api/auth/`)
  notifications: `${API_BASE}/api/auth/notifications/`,
  notificationsUnreadCount: `${API_BASE}/api/auth/notifications/unread_count/`,
  notificationsMarkRead: `${API_BASE}/api/auth/notifications/mark_read/`,
  notificationsMarkByIncident: `${API_BASE}/api/auth/notifications/mark_by_incident/`,

  // Chatbox (RAG-driven) - routed under common app `/api/auth/`
  chatboxMessage: `${API_BASE}/api/auth/chatbox/message/`,
  chatboxHistory: `${API_BASE}/api/auth/chatbox/history/`,

  // Current Order (for A-Sight dynamic features)
  currentOrder: `${API_BASE}/api/ordini/current-order/`,
  myOrders: `${API_BASE}/api/ordini/orders/my-orders/`,

  // Store (public endpoints — no auth)
  storeChannelInfo: `${API_BASE}/api/store/channel-info/`,
  storeListino: `${API_BASE}/api/store/listino/`,
  storeOrderCreate: `${API_BASE}/api/store/ordini/`,

  // Awareness
  awarenessUsers: `${API_BASE}/api/awareness/users/`,
  awarenessUserDetail: (id) => `${API_BASE}/api/awareness/users/${id}/`,
  awarenessUsersExportCSV: `${API_BASE}/api/awareness/users/export_csv/`,
  awarenessSendActivationEmail: (id) => `${API_BASE}/api/awareness/users/${id}/send_activation_email/`,
  awarenessDashboard: `${API_BASE}/api/awareness/dashboard/`,
  awarenessDashboardCompany: (companyId) => `${API_BASE}/api/awareness/dashboard/${companyId}/`,
  awarenessDashboardSummary: `${API_BASE}/api/awareness/dashboard/summary/`,
  awarenessDashboardSummaryCompany: (companyId) => `${API_BASE}/api/awareness/dashboard/${companyId}/summary/`,
  // Awareness per reparto (la heatmap è dietro ?heatmap=true: solo per il dettaglio)
  awarenessDepartments: `${API_BASE}/api/awareness/departments/`,
  awarenessDepartmentsCompany: (companyId) => `${API_BASE}/api/awareness/departments/${companyId}/`,
  awarenessDepartmentTargets: `${API_BASE}/api/awareness/departments/targets/`,
  awarenessDepartmentTargetsCompany: (companyId) => `${API_BASE}/api/awareness/departments/${companyId}/targets/`,
  awarenessDepartmentsExport: `${API_BASE}/api/awareness/departments/export/`,
  awarenessDepartmentsExportCompany: (companyId) => `${API_BASE}/api/awareness/departments/${companyId}/export/`,

};

export default API_ENDPOINTS;